import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Quote, Star } from 'lucide-react';

const Testimonials = () => {
  const { t } = useLanguage();

  const testimonials = [
    {
      name: t('testimonial1Name'),
      role: t('testimonial1Role'),
      content: t('testimonial1'),
      rating: 5,
      image: 'https://ui-avatars.com/api/?name=Ahmed+Al+Mansoori&background=d97706&color=fff&size=200'
    },
    {
      name: t('testimonial2Name'),
      role: t('testimonial2Role'),
      content: t('testimonial2'),
      rating: 5,
      image: 'https://ui-avatars.com/api/?name=Sarah+Al+Shamsi&background=d97706&color=fff&size=200'
    },
    {
      name: t('testimonial3Name'),
      role: t('testimonial3Role'),
      content: t('testimonial3'),
      rating: 5,
      image: 'https://ui-avatars.com/api/?name=Mohammed+Al+Kaabi&background=d97706&color=fff&size=200'
    }
  ];

  return (
    <section id="testimonials" className="relative py-24 bg-gradient-to-b from-white to-amber-50/50">
      {/* Background decorations */}
      <div className="absolute top-1/3 right-0 w-96 h-96 bg-amber-100/40 rounded-full blur-3xl" />
      <div className="absolute bottom-1/3 left-0 w-96 h-96 bg-amber-100/40 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block mb-4">
            <span className="px-4 py-2 bg-amber-100 border border-amber-300 rounded-full text-amber-700 text-sm font-medium">
              {t('testimonials')}
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            {t('testimonialsTitle')}
          </h2>
          <p className="text-lg text-slate-600">
            {t('testimonialsSubtitle')}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="group relative bg-white border-2 border-amber-200 rounded-2xl p-8 hover:border-amber-400 transition-all duration-500 hover:shadow-2xl hover:shadow-amber-500/20 hover:-translate-y-2"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 opacity-10 group-hover:opacity-20 transition-opacity">
                <Quote className="w-12 h-12 text-amber-600" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star 
                    key={i} 
                    className="w-5 h-5 fill-amber-500 text-amber-500" 
                  />
                ))}
              </div>

              {/* Content */}
              <p className="text-slate-600 leading-relaxed mb-6 relative z-10">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-amber-200">
                <div className="relative">
                  <div className="absolute inset-0 bg-amber-200/40 rounded-full blur-lg" />
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="relative w-14 h-14 rounded-full border-2 border-amber-300"
                  />
                </div>
                <div>
                  <h4 className="text-slate-900 font-semibold group-hover:text-amber-600 transition-colors">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-slate-600">
                    {testimonial.role}
                  </p>
                </div>
              </div>

              {/* Decorative gradient */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-b-2xl" />
            </div>
          ))}
        </div>

        {/* Rating Summary */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-4 bg-white border-2 border-amber-200 rounded-full px-8 py-4 shadow-lg">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star 
                  key={i} 
                  className="w-6 h-6 fill-amber-500 text-amber-500" 
                />
              ))}
            </div>
            <div className="h-8 w-px bg-amber-300" />
            <div className="text-left">
              <div className="text-2xl font-bold text-slate-900">5.0</div>
              <div className="text-sm text-slate-600">
                {t('language') === 'ar' ? 'تقييم العملاء' : 'Client Rating'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
